import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['input', 'count', 'warning'];
  static values = {
    maxLength: Number,
  };

  connect() {
    this.updateCharCount();
  }

  updateCharCount() {
    const currentLength = this.inputTarget.innerText.length;
    this.countTarget.textContent = currentLength;

    if (currentLength > this.maxLengthValue) {
      this.showWarning();
    } else {
      this.hideWarning();
    }

    this.updateCountColor(currentLength);
  }

  updateCountColor(currentLength) {
    const percentage = (currentLength / this.maxLengthValue) * 100;

    this.countTarget.classList.remove('text-success', 'text-warning', 'text-danger');

    if (percentage < 85) {
      this.countTarget.classList.add('text-primary');
    } else if (percentage < 95) {
      this.countTarget.classList.add('text-warning');
    } else {
      this.countTarget.classList.add('text-danger');
    }
  }

  showWarning() {
    this.warningTarget.classList.remove('d-none');
  }

  hideWarning() {
    this.warningTarget.classList.add('d-none');
  }
}
